import moment from 'moment/moment';

export default {
  formattedDate(date) {
    return moment(date).format('MM/DD/YYYY');
  },
};



// WEBPACK FOOTER //
// ./src/classes/Date.js